module.exports = "https://web-assets-production.autolist.com/_next/static/images/trending-sedans-6b919d1aaa6e659b5d5b0d91b57c0aed.jpg";